import { render, staticRenderFns } from "./projekte.vue?vue&type=template&id=7a728c04&scoped=true&"
import script from "./projekte.vue?vue&type=script&lang=js&"
export * from "./projekte.vue?vue&type=script&lang=js&"
import style0 from "./projekte.vue?vue&type=style&index=0&id=7a728c04&prod&lang=css&"
import style1 from "./projekte.vue?vue&type=style&index=1&id=7a728c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a728c04",
  null
  
)

export default component.exports